import { render, staticRenderFns } from "./Alerts.vue?vue&type=template&id=002fdb1f&scoped=true"
import script from "./Alerts.vue?vue&type=script&lang=js"
export * from "./Alerts.vue?vue&type=script&lang=js"
import style0 from "./Alerts.vue?vue&type=style&index=0&id=002fdb1f&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002fdb1f",
  null
  
)

export default component.exports